export const userRoleFields = () => [
    {
        name: 'user_role_name',
        type: 'text',
        label: 'User Role Name',
        required: true,
    },
    {
        name: 'empty_col_1',
        type: 'empty-column',
    },
    {
        name: 'empty_col_2',
        type: 'empty-column',
    },
   
    {
        name: 'description',
        type: 'textarea',
        colSpan: 6,
    },
];
